import React from "react";
import ModuleCreate from "./views/learning/Pages/ModuleCreate";
import SubModuleCreatePage from "./views/learning/Pages/SubModuleCreatePage";
import SubmoduleCreate from "./views/learning/Pages/_SubmoduleCreate";
import SubmodulEdit from "./views/learning/Pages/SubModuleEdit";
import ModuleDetailPage from "./views/learning/Pages/ModuleDetailPage";
import ModuleEdit from "./views/learning/Pages/ModuleEdit";
import Login from './views/pages/login/Login';
import Register from './views/pages/register/Register';
import RegisterAdmin from './views/learning/Register/RegisterAdmin';
import Admin from "./views/pages/admin/Admin";
import Export from "./views/export/Export";
import Export2 from "./views/export/Export2";
import {Route} from "react-router-dom";
import AdminPage from "./views/learning/Pages/AdminPage";
import Role from "./utils/Role";

const Toaster = React.lazy(() =>
  import("./views/notifications/toaster/Toaster")
);
const Tables = React.lazy(() => import("./views/base/tables/Tables"));

const Breadcrumbs = React.lazy(() =>
  import("./views/base/breadcrumbs/Breadcrumbs")
);
const Cards = React.lazy(() => import("./views/base/cards/Cards"));
const Carousels = React.lazy(() => import("./views/base/carousels/Carousels"));
const Collapses = React.lazy(() => import("./views/base/collapses/Collapses"));
const BasicForms = React.lazy(() => import("./views/base/forms/BasicForms"));

const Jumbotrons = React.lazy(() =>
  import("./views/base/jumbotrons/Jumbotrons")
);
const ListGroups = React.lazy(() =>
  import("./views/base/list-groups/ListGroups")
);
const Navbars = React.lazy(() => import("./views/base/navbars/Navbars"));
const Navs = React.lazy(() => import("./views/base/navs/Navs"));
const Paginations = React.lazy(() =>
  import("./views/base/paginations/Pagnations")
);
const Popovers = React.lazy(() => import("./views/base/popovers/Popovers"));
const ProgressBar = React.lazy(() =>
  import("./views/base/progress-bar/ProgressBar")
);
const Switches = React.lazy(() => import("./views/base/switches/Switches"));

const Tabs = React.lazy(() => import("./views/base/tabs/Tabs"));
const Tooltips = React.lazy(() => import("./views/base/tooltips/Tooltips"));
const BrandButtons = React.lazy(() =>
  import("./views/buttons/brand-buttons/BrandButtons")
);
const ButtonDropdowns = React.lazy(() =>
  import("./views/buttons/button-dropdowns/ButtonDropdowns")
);
const ButtonGroups = React.lazy(() =>
  import("./views/buttons/button-groups/ButtonGroups")
);
const Buttons = React.lazy(() => import("./views/buttons/buttons/Buttons"));
const Charts = React.lazy(() => import("./views/charts/Charts"));
const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const CoreUIIcons = React.lazy(() =>
  import("./views/icons/coreui-icons/CoreUIIcons")
);
const Flags = React.lazy(() => import("./views/icons/flags/Flags"));
const Brands = React.lazy(() => import("./views/icons/brands/Brands"));
const Alerts = React.lazy(() => import("./views/notifications/alerts/Alerts"));
const Badges = React.lazy(() => import("./views/notifications/badges/Badges"));
const Modals = React.lazy(() => import("./views/notifications/modals/Modals"));
const Colors = React.lazy(() => import("./views/theme/colors/Colors"));
const Typography = React.lazy(() =>
  import("./views/theme/typography/Typography")
);
const Widgets = React.lazy(() => import("./views/widgets/Widgets"));
const Users = React.lazy(() => import("./views/users/Users"));
// const Module = React.lazy(() => import("./views/users/Module"));
const UserPage = React.lazy(() => import("./views/learning/Pages/UserPage"));
const ModulePage = React.lazy(() => import("./views/learning/Pages/ModulePage"));
const SubmodulePage = React.lazy(() =>
  import("./views/learning/Pages/SubmodulePage")
);
const User = React.lazy(() => import("./views/learning/Pages/User"));
const RegisterUser = React.lazy(() =>
  import("./views/learning/Register/RegisterUser")
);

const routes = [
  { path: "/", exact: true, name: "Home", component: ModulePage },
  { path: "/branches", exact: true, name: "Pelatihan", component: ModulePage },
  { path: "/submodules", exact: true, name: "Modul", component: SubmodulePage },
  {
    path: "/branches/:id",
    exact: true,
    name: "Detil Modul",
    component: ModuleDetailPage,
  },
  {
    path: "/login",
    exact: true,
    name: "Halaman Logout",
    component: Login,
  },
  {
    path: "/register",
    exact: true,
    name: "Halaman Registrasi",
    component: Register,
  },
  {
    path: "/profile",
    exact: true,
    name: "Profile",
    component: User,
  },
  // {
  //   path: "/dashboard",
  //   exact: true,
  //   name: "Dashboard",
  //   component: Dashboard
  // },
  // {
  //   path: "/widget",
  //   exact: true,
  //   name: "Widget",
  //   component: Widgets
  // }
];

export default routes;
